/** @format */

import {IconButton} from '@mui/material';
import {styled} from '@mui/material/styles';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const PREFIX = 'DisconnectButton';

const classes = {
  button: `${PREFIX}-button`,
};

const StyledIconButton = styled(IconButton)(() => ({
  [`& .${classes.button}`]: {
    backgroundColor: '#332323',
    height: 44,
    width: 44,
    '&:hover': {
      backgroundColor: '#231313',
    },
  },
}));

interface Props {
  className: string;
  onDisconnect: () => void;
}

const DisconnectButton = ({className, onDisconnect}: Props) => {
  return (
    <StyledIconButton className={className} onClick={onDisconnect} size='large'>
      <RemoveCircleIcon fontSize='small' htmlColor='#AE5658' />
    </StyledIconButton>
  );
};

export default DisconnectButton;
